import React from "react";

//components
import BasicTextInput from "../../textInputs/BasicTextInput";
import BasicButton from "../../buttons/BasicButton";
import Icon from "../../icons/Icon";
import DragButton from "../../buttons/DragButton";

//interfaces
import { ITextOptionListItem } from "../../../../interfaces/lists/ITextOptionList";
import { IconLibrary } from "../../../../interfaces/icon/IconLibrary";

//hook
import UseTextOptionListItem from "./TextOptionListItem.hooks";



const TextOptionListItem = ({
        id,
        text,
        placeholderText,
        index,
        hoverIndex,
        onEditOptionText,
        onDeleteOptionClick,
        containerRef, 
        moveListItem,
        setHoverIndex, 
        dragAndDropAction,
        key
    }: ITextOptionListItem) => {   

    const {isDragging, dragRef, rowRef} = UseTextOptionListItem({index, hoverIndex, containerRef, moveListItem, setHoverIndex, dragAndDropAction});
    
    return (
        <li ref={rowRef} className={`text-option-list-item ${isDragging ? "is-dragging" : ""}  ${index === hoverIndex ? "is-hovering" : ""}`} key={key}>
            <BasicTextInput 
                className="text-option-input"
                labelText={`Option text input at index ${id}`} 
                labelIsHidden={true}
                placeholderText={placeholderText || "Option"} 
                textString={text}
                setTextString={(text: string) => onEditOptionText(id, text)} 
            />
        
            <BasicButton 
                className="remove-text-option-button"
                ariaLabel={"remove option from list"} 
                content={<Icon iconName={IconLibrary.BIN} color="var(--thriveGreyDark)" sizeInPx="12" />} 
                onButtonClick={()=> onDeleteOptionClick(id)}
            />  
                
            <DragButton 
                dragRef={dragRef}
                className={"text-option-drag-and-drop"}
            />
        </li>
    );
}

export default TextOptionListItem